module.exports = __webpack_public_path__ + "static/media/Hoist_ios_4_preview.8ff2c5bb.jpg";